import unit from './unit';

export default function micron(value, decimals = 0) {
  return unit(value, 'μm', decimals);
}
